import { extend } from 'flarum/common/extend';
import PostControls from 'flarum/forum/utils/PostControls';
import app from 'flarum/forum/app';

app.initializers.add('flarum-permission-patch-forum', () => {
  extend(PostControls, 'controlItems', function (items, post) {
    const user = app.session.user;

    if (!user || !post.user() || post.user().id() !== user.id()) return;

    const createdAt = new Date(post.createdAt());
    const diffInMinutes = (new Date() - createdAt) / 60000;

    // --- EDIT PERMISSIONS ---
    const canEditInfinite = app.forum.attribute('canEditOwnPostInfinite');
    const canEdit24h      = app.forum.attribute('canEditOwnPost24h');
    const canEdit10min    = app.forum.attribute('canEditOwnPost10min');

    const allowEdit =
      canEditInfinite ||
      (canEdit24h   && diffInMinutes <= 24 * 60) ||
      (canEdit10min && diffInMinutes <= 10);

    if (!allowEdit) {
      items.remove('edit');
    }

    // --- DELETE/HIDE PERMISSIONS ---
    const canDeleteInfinite = app.forum.attribute('canDeleteOwnPostInfinite');
    const canDelete24h      = app.forum.attribute('canDeleteOwnPost24h');
    const canDelete10min    = app.forum.attribute('canDeleteOwnPost10min');

    const allowDelete =
      canDeleteInfinite ||
      (canDelete24h   && diffInMinutes <= 24 * 60) ||
      (canDelete10min && diffInMinutes <= 10);

    if (!allowDelete) {
      items.remove('hide');
      items.remove('delete');
    }
  });
});
